var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-detail-container"},[_c('components-separate',{attrs:{"title":"视频播放","desc":"VIDEO PLAYER"}}),_c('video',{staticClass:"my-video",attrs:{"src":_vm.$route.query.url,"autoplay":"","controls":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }